<template>
  <v-app>
    <div id="aboutus">
      <section id="headeraboutusid">
        <HeaderAboutUs />
      </section>

      <v-main>
        <section id="aboutusid">
          <!-- About LETOUR -->
          <v-container fluid>
            <div data-aos="fade-up" data-aos-delay="300">
              <h1
                class="primary--text text-center font-weight-black my-10 mt-15"
                :style="
                  this.$vuetify.breakpoint.mdAndUp ? 'font-size: 50px' : 'font-size: 40px'
                "
              >
                {{ $t("aboutus.aboutletour") }}
              </h1>
            </div>
            <v-row>
              <v-col>
                <v-card elevation="3" class="mx-auto" max-width="80%">
                  <v-card-text>
                    <h2
                      class="blue--text text--darken-3 text-center font-weight-black my-5"
                      style="font-size: 30px"
                    >
                      {{ $t("aboutus.whoarewe") }}
                    </h2>
                    <p
                      :class="
                        this.$vuetify.breakpoint.mdAndUp
                          ? 'text-center font-weight-bold my-5 mx-4'
                          : 'text-center font-weight-bold my-5 mx-5'
                      "
                      style="font-size: 18px; line-height: 1.5"
                    >
                      {{ $t(about.letour) }}
                    </p>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <!-- LETOUR Purpose -->
            <v-row :class="this.$vuetify.breakpoint.mdAndUp ? 'mx-11 px-5' : ''">
              <v-col cols="12">
                <div data-aos="fade-up" data-aos-delay="300">
                  <h1
                    class="primary--text text-center my-10"
                    :style="
                      this.$vuetify.breakpoint.mdAndUp
                        ? 'font-size: 50px'
                        : 'font-size: 40px'
                    "
                  >
                    {{ $t("aboutus.ourpurpose") }}
                  </h1>
                </div>
              </v-col>
              <v-col md="6">
                <v-card elevation="3" class="mx-auto" max-width="70%">
                  <v-card-text>
                    <h2
                      class="blue--text text--darken-3 text-center font-weight-black my-5"
                      style="font-size: 30px"
                    >
                      {{ $t("aboutus.ourvision") }}
                    </h2>
                    <p
                      :class="
                        this.$vuetify.breakpoint.mdAndUp
                          ? 'text-center font-weight-bold my-5 mx-4'
                          : 'text-center font-weight-bold my-5 mx-5'
                      "
                      style="font-size: 18px; line-height: 1.5"
                    >
                      {{ $t(about.vision) }}
                    </p>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col md="6">
                <v-card elevation="3" class="mx-auto" max-width="70%">
                  <v-card-text>
                    <h2
                      class="blue--text text--darken-3 text-center font-weight-black my-5"
                      style="font-size: 30px"
                    >
                      {{ $t("aboutus.ourmission") }}
                    </h2>
                    <p
                      :class="
                        this.$vuetify.breakpoint.mdAndUp
                          ? 'text-center font-weight-bold my-5 mx-4'
                          : 'text-center font-weight-bold my-5 mx-5'
                      "
                      style="font-size: 18px; line-height: 1.5"
                    >
                      {{ $t(about.mission) }}
                    </p>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <!-- LETOUR Partner -->
            <div class="my-5">
              <div data-aos="fade-up" data-aos-delay="300">
                <h1
                  class="primary--text text-center mt-10"
                  :style="
                    this.$vuetify.breakpoint.mdAndUp
                      ? 'font-size: 50px'
                      : 'font-size: 40px'
                  "
                >
                  {{ $t("aboutus.ourpartners") }}
                </h1>
              </div>
              <v-container fill-height>
                <v-row class="justify-center align-center">
                  <v-col
                    cols="6"
                    sm="6"
                    md="3"
                    lg="2"
                    v-for="partner in partners"
                    :key="partner.src"
                  >
                    <a :href="partner.router" target="_blank">
                      <v-img
                        :src="require(`@/assets/partner/` + partner.image)"
                        :min-height="partner.height"
                        :max-width="partner.width"
                        style="margin: 0 auto"
                      >
                      </v-img>
                    </a>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </v-container>
        </section>
        <ScrollUp />
        <Footer />
      </v-main>
    </div>
  </v-app>
</template>

<script>
import HeaderAboutUs from "@/components/HeaderAboutUs";
import ScrollUp from "@/components/ScrollUp";
import Footer from "@/components/Footer";

export default {
  name: "About_Us",
  components: {
    HeaderAboutUs,
    ScrollUp,
    Footer,
  },

  data: () => ({
    about: {
      letour: "aboutus.letour",
      vision: "aboutus.vision",
      mission: "aboutus.mission",
    },

    partners: [
      {
        image: "Zeal.png",
        width: "150px",
        height: "110px",
      },
      {
        image: "KGF.png",
        width: "170px",
        height: "140px",
      },
      {
        router: "https://vkirirom.com/",
        image: "vKirirom.png",
        width: "130px",
        height: "100px",
      },
      {
        router: "https://kit.edu.kh/",
        image: "KIT.png",
        width: "150px",
        height: "70px",
      },
      {
        router: "https://quadusk.com/",
        image: "QUADUSK.png",
        width: "110px",
        height: "120px",
      },
    ],
  }),
};
</script>

<style scoped>
* {
  font-family: "Montserrat", sans-serif;
}
@media only screen and (max-width: 330px) {
  h2 {
    line-height: 33px;
  }
}
@media only screen and (max-width: 665px) and (min-width: 427px) {
  h2 {
    line-height: 33px;
  }
}
</style>
